import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33f6b44e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "search_container" }
const _hoisted_3 = { class: "search_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("下一条")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableLayout = _resolveComponent("TableLayout")!
  const _component_VerifyDialog = _resolveComponent("VerifyDialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_TableLayout, null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchHandle.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchHandle.id) = $event)),
                class: "search_input",
                placeholder: "请输入模板ID"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchHandle.designer_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchHandle.designer_id) = $event)),
                class: "search_input",
                placeholder: "请输入设计师ID"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.format,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchHandle.format) = $event)),
                clearable: "",
                class: "search_input",
                placeholder: "请选择格式"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.formatList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.searchHandle.search
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                onClick: _ctx.searchHandle.reset
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        main: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            height: "100%",
            border: "",
            "span-method": _ctx.objectSpanMethod,
            data: _ctx.tableHandle.mats,
            class: "table_box",
            "row-key": "newId",
            onSortChange: _ctx.sortByDesignerId
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "120",
                prop: "id",
                label: "模板ID"
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "140",
                prop: "designer_id",
                label: "设计师ID",
                sortable: "custom"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                prop: "upload_time",
                label: "上传时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(new Date(scope.row.up_load_time), 'yyyy-MM-dd hh:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "250",
                prop: "title",
                label: "模板标题"
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "120",
                prop: "small_img",
                label: "缩略图"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_image, {
                    src: scope.row.small_img,
                    "hide-on-click-modal": true,
                    "preview-src-list": [scope.row.small_img],
                    fit: "contain"
                  }, null, 8, ["src", "preview-src-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "120",
                prop: "big_img",
                label: "预览图"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_image, {
                    src: scope.row.big_img || scope.row.big_imgs[0],
                    "hide-on-click-modal": true,
                    lazy: "",
                    "preview-src-list": scope.row.big_imgs,
                    fit: "contain"
                  }, null, 8, ["src", "preview-src-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "175",
                prop: "preview_video",
                label: "预览视频"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.preview_video)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        width: "150",
                        height: "150",
                        src: scope.row.preview_video,
                        controls: ""
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "120",
                prop: "scene",
                label: "分发场景"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.formatScene(scope.row.scene)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "200",
                prop: "tag",
                label: "模板标签"
              }, {
                default: _withCtx((scope) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTagsArr(scope.row.tag), (tag, idx) => {
                    return (_openBlock(), _createBlock(_component_el_tag, { key: idx }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "100",
                prop: "format",
                label: "模板格式"
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "100",
                prop: "size",
                label: "模板大小"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.formatSizeHandle(scope.row.size)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "100",
                prop: "page_count",
                label: "模板页数"
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "250",
                prop: "file_url",
                label: "模板文件"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", {
                    class: "down_file",
                    onClick: ($event: any) => (_ctx.downLoadByUrl(scope.row))
                  }, _toDisplayString(_ctx.getFileTitle(scope.row.relative_file_path)), 9, _hoisted_7)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "80",
                label: "操作",
                fixed: "right",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.tableHandle.clickVerify(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["span-method", "data", "onSortChange"])), [
            [_directive_loading, _ctx.tableHandle.loading]
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            align: "right",
            "current-page": _ctx.paginationHandle.page,
            "page-size": _ctx.paginationHandle.size,
            total: _ctx.paginationHandle.total,
            onSizeChange: _ctx.paginationHandle.handleSizeChange,
            onCurrentChange: _ctx.paginationHandle.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_VerifyDialog, {
        modelValue: _ctx.tableHandle.matVerifyDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tableHandle.matVerifyDialog) = $event)),
        mat: _ctx.tableHandle.matCur,
        onClickSubmit: _ctx.tableHandle.handleSumbit,
        onClickClose: _ctx.tableHandle.handleClose
      }, null, 8, ["modelValue", "mat", "onClickSubmit", "onClickClose"]),
      (_ctx.tableHandle.matVerifyNextDialog)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 0,
            modelValue: _ctx.tableHandle.matVerifyNextDialog,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tableHandle.matVerifyNextDialog) = $event)),
            "close-on-click-modal": false,
            width: 250,
            title: "审核结果"
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, [
                (_ctx.tableHandle.matNext)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _ctx.tableHandle.clickVerifyMatNext
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "info",
                  onClick: _ctx.tableHandle.clickMatNextClose
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.tableHandle.textNext) + " ", 1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}